import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  const f = t.footer;
  return (
    <footer data-testid="footer-section" className="bg-brand text-white overflow-hidden">
      <div className="max-w-[1360px] mx-auto px-6 md:px-10 lg:px-12 pt-24">
        {/* CTA row */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 pb-16 border-b border-white/12">
          <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight leading-[0.98] max-w-[14ch]">
            Begin your structure.
          </h2>
          <Link
            to="/contact"
            className="group inline-flex items-center gap-3 bg-white text-brand hover:bg-brand-50 transition-colors text-sm font-semibold px-8 py-4 rounded-full shrink-0"
          >
            Private Consultation
            <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 py-16">
          <div className="col-span-2 md:col-span-4">
            <p className="font-display font-bold text-2xl">AURELIUS<span className="text-brand-200">.</span></p>
            <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-sm">{f.about}</p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-widest text-white/40 mb-4">{f.guides}</p>
            <ul className="space-y-2.5 text-sm">
              {f.guidesList.map((g) => (
                <li key={g.slug}>
                  <Link to={`/${g.slug}`} data-testid={`footer-guide-${g.slug}`}
                    className="text-white/70 hover:text-white transition-colors">{g.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-widest text-white/40 mb-4">{f.offices}</p>
            <ul className="space-y-2.5 text-sm text-white/70">
              {f.officesList.map((o) => (<li key={o}>{o}</li>))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-widest text-white/40 mb-4">{f.contact}</p>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact us</Link></li>
              <li>enquiries@aureliusfamilyoffice.com</li>
              <li>+971 4 000 0000</li>
            </ul>
            <p className="mt-6 text-xs text-white/35 leading-relaxed">{f.disclaimer}</p>
          </div>
        </div>
      </div>
      <p className="font-display font-bold text-[15vw] leading-[0.8] text-white/[0.05] text-center select-none pb-4" aria-hidden="true">
        AURELIUS
      </p>
    </footer>
  );
}
